<template>
  <div class="columns is-multiline is-marginless is-main-content is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeJournalEcriture.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeJournalEcriture.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      class="column is-12 is-marginless overflow-auto"
      :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="column is-12 pdb-0">
        <qd-notification type="is-primary"
                        v-if="$route.params.lotPaiementLibelle
                        && critereRecherche.referencePiece.length > 0"
                        class="is-marginless pd-6px"
                        @close="deleteIdFacture()">
          {{ $route.params.lotPaiementLibelle }}
        </qd-notification>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeJournalEcriture.filtre.exercice')">
          <b-select class="column is-paddingless" expanded @input="updateExerciceWithSelect()"
                    v-model="exerciceId">
            <option></option>
            <option :value="exercice.id" v-for="exercice in listeExcercices"
                    :key="exercice.code">
              {{ exercice.code }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 is-marginless">
        <input-periode
          v-model="critereRecherche.dateComptable"
          :label="$t('listeJournalEcriture.filtre.periode')">
        </input-periode>
      </div>
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeJournalEcriture.filtre.lot')"
                      :items="constantes.LISTE_ETAT"
                      v-model="etatLotSelected">
        </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeJournalEcriture.filtre.etat')">
            <b-select v-model="critereRecherche.isValid" expanded>
              <option :value=null></option>
              <option :value="true">{{$t('listeJournalEcriture.etat.valide')}}</option>
              <option :value="false">{{$t('listeJournalEcriture.etat.nonValide')}}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeJournalEcriture.filtre.typeEcriture')"
                      :items="constantes.LISTE_TYPE"
                      v-model="typeEcritureSelected">
          </libelle-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeJournalEcriture.filtre.actions.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeJournalEcriture.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { LISTE_ETAT } from '@/configuration/compta/lotConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import genererCritereRecherche from '@/services/compta/journal/genererCritereRechercheJournalEcriture';
import { SET_CRITERE } from '@/store/modules/compta/journalEcriture-mutation-type';
import { LISTE_TYPE } from '@/configuration/compta/ecritureConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatIsoDate';
import messageErreur from '@/services/general/messageErreur';
import validationFiltre from '@/services/compta/journal/validationFiltre';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import inputPeriode from '@/components/general/inputPeriode';

const journalEcriture = createNamespacedHelpers('journalEcriture');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    libelleTagInput,
    errorMsgComponent,
    inputPeriode,
  },
  computed: {
    ...journalEcriture.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    listeExcercices() {
      return this.parametre(PARAMETRES_KEYS.exercice);
    },
  },
  data() {
    return {
      exerciceId: null,
      errors: [],
      critereRecherche: null,
      constantes: {
        LISTE_ETAT,
        LISTE_TYPE,
      },
      etatLotSelected: [],
      typeEcritureSelected: [],
    };
  },
  methods: {
    ...journalEcriture.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    deleteIdFacture() {
      this.critereRecherche.referencePiece = [];
    },
    viderCritere() {
      this.critereRecherche = genererCritereRecherche();
      this.typeEcritureSelected = [];
      this.exerciceId = null;
      this.initializeAutoComplete();
    },
    appliquerCritere() {
      this.critereRecherche.etatLot = this.etatLotSelected.map((c) => {
        return c.code;
      });
      this.critereRecherche.types = this.typeEcritureSelected.map((ecriture) => {
        return ecriture.code;
      });
      this.errors = [];
      validationFiltre(this.critereRecherche, this.errors);
      if (this.errors.length > 0) return;
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    updateExerciceWithSelect() {
      const exercice = this.listeExcercices.find((ex) => {
        return ex.id === this.exerciceId;
      });
      this.changeExercice(exercice);
    },
    changeExerciceWithDate(dateDebut) {
      if (!dateDebut) return;
      const exercice = this.listeExcercices.find((ex) => {
        return moment(dateDebut).isBetween(moment(ex.dateDebut), moment(ex.dateFin), 'day', '[]');
      });
      this.changeExercice(exercice);
    },
    changeExercice(exercice) {
      this.critereRecherche.exercice.dateDebut = exercice ? formatDate(exercice.dateDebut) : null;
      this.critereRecherche.exercice.dateFin = exercice ? formatDate(exercice.dateFin) : null;
      this.exerciceId = exercice ? exercice.id : null;
    },
    initializeAutoComplete() {
      if (this.critereRecherche.etatLot) {
        this.etatLotSelected = this.constantes.LISTE_ETAT.filter((etat) => {
          return this.critereRecherche.etatLot.includes(etat.code);
        });
      }
      if (this.critereRecherche.types) {
        this.typeEcritureSelected = this.constantes.LISTE_TYPE.filter((etat) => {
          return this.critereRecherche.types.includes(etat.code);
        });
      }
    },

    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametres([PARAMETRES_KEYS.exercice]);
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        this.changeExerciceWithDate(this.critereRecherche.exercice.dateDebut);

        this.initializeAutoComplete();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
